export default __webpack_public_path__ + "static/android-chrome-180-7af71fef7cedca6e8c465f8992d1c2ba.png";